
import { Field, Form, Formik } from 'formik';
import React, { useEffect, useRef, useState } from 'react'
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import logo from '../../assets/tradecruz.png';
import { Request } from '../../hooks/Request';
import { roundToNearest } from '../../utils/validate';
import { ProformParameters } from '../../utils/constant';
import Loading from '../../components/Animation/Loading';
import RenderLiquidaciónProforma from '../../containers/ManegeProcedure/RenderLiquidaciónProforma';
import { useDialog } from '../../contexts/DialogContext';
import { requestAuth } from '../../components/services/RequestService';
import { toast } from 'react-toastify';
import config from "../../config.json";
import { Button } from '../../components/Buttons';

const ProformGeneratorForm = ({ procedure, close }) => {
  const [parametros] = useState(ProformParameters())
  const [dataProcedure, setDataProcedure] = useState(null)
  // const [transportadoras, setTransportadoras] = useState(null)
  const { openDialog, dialogClose } = useDialog();
  const [closeEscPress, setCloseEscPress] = useState(false);

  // const { data: clientes } = Request({
  //   urlApi: `/company/getCompaniesBySelect`
  // });
  const { data: aduanas } = Request({
    urlApi: `/dropdown/listaAduanas/options`
  });
  const { data: modalidades } = Request({
    urlApi: `/dropdown/regimenImportacion/options`
  });
  const { data: proveedores } = Request({
    urlApi: `/dropdown/providers/options`
  });
  const { data: aList } = Request({
    urlApi: `/dropdown/atributos/options`
  });
  const { data: bList } = Request({
    urlApi: `/dropdown/botrosgastos/options`
  });
  const { data: cList } = Request({
    urlApi: `/dropdown/cgastosdeoperaciones/options`
  });
  const { data: dList } = Request({
    urlApi: `/dropdown/dhonorariosprofesionales/options`
  });
  const { data: transportadorasList } = Request({
    urlApi: `/dropdown/tarifas/options`
  });
  const formikRef = useRef(null);

  const { data: initProcedure, loading: procedureLoading } = Request({
    urlApi: procedure ? `/tradecruz/${procedure.id}/perProformGenerator` : null
  });

  const { data: ufvVal } = Request({
    urlApi: `${config.requestContaURL}/api/Ufv/getConfigValues`
  });

  const handleEsc = (event) => {
    if (event.key === "Escape") {
      event.preventDefault();
      setCloseEscPress(x => !x)
    }
  };
  useEffect(() => {
    window.addEventListener("keydown", handleEsc);
    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, []);

  useEffect(() => {
    setDataProcedure(initProcedure)
  }, [initProcedure, ufvVal])

  function generateSettlementProforma(procedure) {
    openDialog(
      <RenderLiquidaciónProforma
        procedure={procedure}
        // openModal={openModal}
        // onClose={onClose}
        openDialog={openDialog}
        dialogClose={dialogClose}
      />
    );
  }

  const callCBlockAverage = async (values, setFieldValue) => {
    await requestAuth(
      "post",
      `/tradecruz/cBlockAverage`,
      {
        procedureId: procedure.id,
        procedureTypeId: procedure.procedureTypeId,
        companyId: procedure.companyId,
        cifUsd: values.cifUsd,
        gastosDespacho: values.gastosDespacho,
        aduana: values.aduana,
        items: values.items,
        gastosDespachoDificultad: values.gastosDespachoDificultad
      }
    )
      .then((response) => {
        let c1bk = response.data.c1;
        let c2bk = response.data.c2;
        let c3bk = response.data.c3;
        let c4bk = response.data.c4;
        let c5bk = response.data.c5;
        let c6bk = response.data.c6;
        let c7bk = response.data.c7;
        setFieldValue('c1bk', c1bk.toFixed(2))
        setFieldValue('c2bk', c2bk.toFixed(2))
        setFieldValue('c3bk', c3bk.toFixed(2))
        setFieldValue('c4bk', c4bk.toFixed(2))
        setFieldValue('c5bk', c5bk.toFixed(2))
        setFieldValue('c6bk', c6bk.toFixed(2))
        setFieldValue('c7bk', c7bk.toFixed(2))
        const amountSum = (values.cSelected || []).reduce((acc, item) => acc + (parseFloat(item.amount) || 0), 0);
        let sumbk = c1bk + c2bk + c3bk + c4bk + c5bk + c6bk + c7bk + amountSum;
        setFieldValue('cTotalbk', sumbk.toFixed(2))
      })
      .catch(() => {
        toast.error("Se produjo un error al guardar");
      });
  }

  const replaceCBlock = async (values, setFieldValue) => {
    let c1bk = values.c1bk;
    let c2bk = values.c2bk;
    let c3bk = values.c3bk;
    let c4bk = values.c4bk;
    let c5bk = values.c5bk;
    let c6bk = values.c6bk;
    let c7bk = values.c7bk;
    setFieldValue('c1', c1bk)
    setFieldValue('c2', c2bk)
    setFieldValue('c3', c3bk)
    setFieldValue('c4', c4bk)
    setFieldValue('c5', c5bk)
    setFieldValue('c6', c6bk)
    setFieldValue('c7', c7bk)

    setFieldValue('c1bk', null)
    setFieldValue('c2bk', null)
    setFieldValue('c3bk', null)
    setFieldValue('c4bk', null)
    setFieldValue('c5bk', null)
    setFieldValue('c6bk', null)
    setFieldValue('c7bk', null)
  }

  const deleteeCBackBlock = async (values, setFieldValue) => {
    setFieldValue('c1bk', null)
    setFieldValue('c2bk', null)
    setFieldValue('c3bk', null)
    setFieldValue('c4bk', null)
    setFieldValue('c5bk', null)
    setFieldValue('c6bk', null)
    setFieldValue('c7bk', null)
    setFieldValue('cTotalbk', null)
  }
  if (procedure && !procedureLoading) {
    return <Loading />;
  }
  else {
    if (procedure && !dataProcedure) {
      return <Loading />;
    }
    return (
      <div className='px-3 py-2 text-[#3f649b] relative'>
        <div className='absolute'>
          <img
            className="h-[50px] sm:h-[55px]"
            src={logo}
            alt="Tradecruz"
          />
        </div>
        <h1 className='text-right text-xl font-semibold'>GENERADOR DE PROFORMA</h1>
        <h1 className='font-bold text-right mb-4'>Nº {dataProcedure?.codigoDeInterno}</h1>
        <div className="flex justify-end items-center gap-2 mb-2">
          {/* <button
            type="button"
            onClick={() => formikRef.current?.resetForm()}
            className="p-2 py-1 bg-yellow-400 text-gray-800 font-semibold rounded"
          >
            Reset Form
          </button> */}
          {
            dataProcedure &&
            <button
              type="button"
              onClick={() => generateSettlementProforma(dataProcedure)}
              className="p-2 py-1 bg-yellow-400 text-gray-800 font-semibold rounded"
            >
              Generar Proforma
            </button>
          }
        </div>
        <Formik
          innerRef={formikRef}
          initialValues={{
            sres: dataProcedure?.sres ?? '',
            companyRazonSocial: dataProcedure?.companyRazonSocial ?? '',
            docEmbarque: dataProcedure?.docEmbarque ?? '',
            prov: dataProcedure?.prov ?? '',
            mercancia: dataProcedure?.mercancia ?? '',
            //
            nit: dataProcedure?.nit ?? '',
            intAgencia: dataProcedure?.intAgencia ?? '',
            facturas: dataProcedure?.facturas ?? '',
            bultos: dataProcedure?.bultos ?? '0',
            peso: dataProcedure?.peso ?? '0.00',
            //
            fobSus: dataProcedure?.fobSus ?? '0.00',
            flete1Sus: dataProcedure?.flete1Sus ?? '0.00',
            flete2Sus: dataProcedure?.flete2Sus ?? '0.00',
            seguroSus: dataProcedure?.seguroSus ?? '0.00',
            otrosGastosSus: dataProcedure?.otrosGastosSus ?? '0.00',
            cifUsd: dataProcedure?.cifUsd ?? '0.00',
            tc: dataProcedure?.tc ?? '6.96',
            cifBs: dataProcedure?.cifBs ?? '0.00',
            //
            aduana: dataProcedure?.aduana ?? '',
            modalidad: dataProcedure?.modalidad ?? '',
            items: dataProcedure?.items ?? '0',
            quincenas: dataProcedure?.quincenas ?? '0.00',
            ga: dataProcedure?.ga ?? 10.00,
            iva: dataProcedure?.iva ?? 14.94,
            transportadora: dataProcedure?.transportadora ?? 'NINGUNO',
            levanteAbandono: dataProcedure?.levanteAbandono ?? 'NO',
            reimpresionDePrm: dataProcedure?.reimpresionDePrm ?? 'NO',
            ufv: dataProcedure?.ufv ?? '0.00',
            //
            tcUfv: dataProcedure?.tcUfv ?? ufvVal?.ufvValue ?? 2.94641,
            tipoDespacho: dataProcedure?.tipoDespacho ?? dataProcedure?.tipoDespacho ?? '',
            tarifaPorExamenPrevioAlbo: dataProcedure?.tarifaPorExamenPrevioAlbo ? (dataProcedure?.tarifaPorExamenPrevioAlbo === 'true' ? true : false) : false,
            tarifa1: dataProcedure?.tarifa1 ?? '0.00',
            tarifa2: dataProcedure?.tarifa2 ?? '118.3',
            transporteLocal: dataProcedure?.transporteLocal ? (dataProcedure?.transporteLocal === 'true' ? true : false) : false,
            tipoPeso: dataProcedure?.tipoPeso ?? 'MINIMA',
            distancia: dataProcedure?.distancia ?? 'NORMAL',
            sobredimension: dataProcedure?.sobredimension ?? 'NORMAL',
            nroEstibadores: dataProcedure?.nroEsdtibadores ?? '0',
            dificultadCarga: dataProcedure?.dificultadCarga ?? 'NORMAL',
            gastosDespacho: dataProcedure?.gastosDespacho ?? 'CORTO (C)',
            gastosDespachoDificultad: dataProcedure?.gastosDespachoDificultad ?? 'NORMAL (N)',
            examenPrevio: dataProcedure?.examenPrevio ? (dataProcedure?.examenPrevio === 'true' ? true : false) : false,
            exPrev: dataProcedure?.exPrev ?? 'NORMAL (N)',
            gestionesSenasag: dataProcedure?.gestionesSenasag ?? 'NINGUNO',
            tieneDescuento: dataProcedure?.tieneDescuento ? (dataProcedure?.tieneDescuento === 'true' ? true : false) : false,
            //
            a1: dataProcedure?.a1 ?? '0.00',
            a2: dataProcedure?.a2 ?? '0.00',
            a3: dataProcedure?.a3 ?? '100',
            a4: dataProcedure?.a4 ?? '0.00',
            a5: dataProcedure?.a5 ?? '0.00',
            aSelected: dataProcedure?.aSelected ?? [],
            aTotal: '0.00',
            //
            b1: dataProcedure?.b1 ?? '0.00',
            b2: dataProcedure?.b2 ?? '0.00',
            b3: dataProcedure?.b3 ?? '0.00',
            b4: dataProcedure?.b4 ?? '0.00',
            b5: dataProcedure?.b5 ?? '0.00',
            b6: dataProcedure?.b6 ?? '0.00',
            bSelected: dataProcedure?.bSelected ?? [],
            bTotal: '0.00',
            //
            c1: dataProcedure?.c1 ?? '0.00',
            c2: dataProcedure?.c2 ?? '0.00',
            c3: dataProcedure?.c3 ?? '0.00',
            c4: dataProcedure?.c4 ?? '0.00',
            c5: dataProcedure?.c5 ?? '0.00',
            c6: dataProcedure?.c6 ?? '0.00',
            c7: dataProcedure?.c7 ?? '0.00',
            cSelected: dataProcedure?.cSelected ?? [],
            cTotal: '0.00',
            //
            d1: dataProcedure?.d1 ?? '0.00',
            d2: dataProcedure?.d2 ?? '140.00',
            dSelected: dataProcedure?.dSelected ?? [],
            dTotal: '0.00',
            //
            tribAduaneros: '0.00',
            descuento: dataProcedure?.descuento ?? '0.00',
            totalProf: '0.00',
            totalProfUsd: '0.00',
            //
            obs: dataProcedure?.obs ?? '',
            obsProf: dataProcedure?.obsProf ?? '',
          }}

          onSubmit={async values => {
            // console.log(values)

            if (proveedores.filter(x => x.name === values.prov).length > 0) {
              await requestAuth(
                "put",
                `/tradecruz/saveProform`,
                { ...values, procedureId: procedure.id }
              )
                .then(() => {
                  close();
                  toast.success("Registro exitoso");
                })
                .catch(() => {
                  toast.error("Se produjo un error al guardar");
                });
            }
            else {
              await requestAuth("post", "/dropdown/option", {
                Name: values.prov,
                DropdownListLabel: "providers",
              });
              await requestAuth(
                "put",
                `/tradecruz/saveProform`,
                { ...values, procedureId: procedure.id }
              )
                .then(() => {
                  close();
                  toast.success("Registro exitoso");
                })
                .catch(() => {
                  toast.error("Se produjo un error al guardar");
                });
            }
            // await requestAuth(
            //   "put",
            //   `/tradecruz/saveProform`,
            //   { ...values, procedureId: procedure.id }
            // )
            //   .then(() => {
            //     close();
            //     toast.success("Registro exitoso");
            //   })
            //   .catch(() => {
            //     toast.error("Se produjo un error al guardar");
            //   });
          }
          }
        >
          {({ values, setFieldValue, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
            <Form className='grid grid-cols-12 gap-1 items-start'>
              {/* <div className='col-span-12 grid grid-cols-12 gap-1 items-start'> */}
              <TableInfo3>
                <SubTitleDivider
                  text={'DATOS DE CABECERA'}
                />
                <TableInfo2>
                  {
                    [
                      {
                        label: 'Señor(es)',
                        subLabel: '',
                        name: 'companyRazonSocial',
                        required: true,
                        isBigValue: true,
                        disabled: true,
                        type: 'text',
                        // options: clientes?.map((i) => ({
                        //   label: i.razonSocial,
                        //   value: i.id,
                        //   nit: i.nit,
                        // })),
                        // options: [],
                        // defaultValueOption: dataProcedure?.sres ? { label: dataProcedure?.companyRazonSocial, value: dataProcedure?.sres, nit: dataProcedure.nit } : null,
                      },
                      {
                        label: 'Doc. Embarque',
                        subLabel: '',
                        name: 'docEmbarque',
                        isBigValue: true,
                      },
                      {
                        label: 'Proveedor',
                        subLabel: '',
                        name: 'prov',
                        isBigValue: true,
                        required: true,
                        type: 'createSelect',
                        options: proveedores?.map((i) => ({
                          label: i.name,
                          value: i.name,
                        })),
                      },
                      {
                        label: 'Mercancía',
                        subLabel: '',
                        name: 'mercancia',
                        required: true,
                        isBigValue: true,
                      },
                    ].map((i, idx) => (
                      <Input
                        key={idx}
                        {...i}
                        values={values}
                        setFieldValue={setFieldValue}
                        placeholder=''
                      />
                    ))
                  }
                </TableInfo2>
                <TableInfo2>
                  {
                    [
                      {
                        label: 'Nit',
                        subLabel: '',
                        name: 'nit',
                        isBigValue: true,
                        disabled: true,
                        type: 'text',
                        // func: (values) => {
                        //   let sres = values?.sres
                        //   let nit = values?.nit
                        //   setFieldValue('nit', nit ?? '')
                        // },
                        // execFuncDependecy: (values) => [values.sres]
                      },
                      {
                        label: 'Int. Agencia',
                        subLabel: '',
                        name: 'intAgencia',
                        required: false,
                        isBigValue: true,
                      },
                      {
                        label: 'Factura(s)',
                        subLabel: '',
                        name: 'facturas',
                        required: true,
                        isBigValue: true,
                      },
                    ].map((i, idx) => (
                      <Input
                        key={idx}
                        {...i}
                        values={values}
                        setFieldValue={setFieldValue}
                        placeholder=''
                      />
                    ))
                  }
                </TableInfo2>
              </TableInfo3>
              <div className='col-span-12 grid grid-cols-12 gap-1 items-start'>
                <TableInfo>
                  <SubTitleDivider
                    text={'VALORES GENERALES'}
                  // color={'blue-600'}
                  />
                  {
                    [
                      {
                        label: 'Valor FOB',
                        subLabel: '$us.',
                        name: 'fobSus',
                        type: 'number',
                        required: true,
                        focus: true,
                        markEdits: ['seguroSus', 'a1', 'a2', 'a4', 'b1', 'c3', 'c5', 'c7', 'd1']
                      },
                      {
                        label: 'Flete I',
                        subLabel: '$us.',
                        name: 'flete1Sus',
                        required: true,
                        type: 'number',
                        markEdits: ['a1', 'a2', 'a4', 'b1', 'd1']
                      },
                      {
                        label: 'Flete II',
                        subLabel: '$us.',
                        name: 'flete2Sus',
                        required: true,
                        type: 'number',
                        markEdits: ['a1', 'a2', 'a4', 'b1', 'd1']
                      },
                      {
                        label: 'Seguro',
                        subLabel: '$us.',
                        name: 'seguroSus',
                        required: true,
                        type: 'number',
                        title: 'Valor FOB * 0.02',
                        markEdits: ['a1', 'a2', 'a4', 'b1', 'd1'],
                        func: (values) => {
                          if (!(values.seguroSusEdit || dataProcedure.seguroSus === null || dataProcedure.seguroSus === '' || dataProcedure.seguroSus === '-')) return;
                          let fobSus = parseFloat(values?.fobSus) || 0
                          let sum = fobSus * 0.02
                          setFieldValue('seguroSus', sum.toFixed(2))
                        },
                        execFuncDependecy: (values) => [values.fobSus]
                      },
                      {
                        label: 'Otros gastos',
                        subLabel: '$us.',
                        name: 'otrosGastosSus',
                        required: true,
                        type: 'number',
                        markEdits: ['a1', 'a2', 'a4', 'b1', 'd1'],
                      },
                      {
                        label: 'Valor CIF USD',
                        subLabel: '$us.',
                        name: 'cifUsd',
                        type: 'number',
                        required: true,
                        disabled: true,
                        func: (values) => {
                          let fobSus = parseFloat(values?.fobSus) || 0
                          let flete1Sus = parseFloat(values?.flete1Sus) || 0
                          let flete2Sus = parseFloat(values?.flete2Sus) || 0
                          let seguroSus = parseFloat(values?.seguroSus) || 0
                          let otrosGastosSus = parseFloat(values?.otrosGastosSus) || 0
                          let sum = fobSus + flete1Sus + flete2Sus + seguroSus + otrosGastosSus
                          setFieldValue('cifUsd', sum.toFixed(2))
                        },
                        execFuncDependecy: (values) => [values?.fobSus, values?.flete1Sus, values?.flete2Sus, values?.seguroSus, values?.otrosGastosSus],
                        markEdits: ['a1', 'a2', 'a4', 'b1', 'd1']
                      },
                      {
                        label: 'T.C.',
                        subLabel: '',
                        name: 'tc',
                        required: true,
                        type: 'number',
                        markEdits: ['a1', 'a2', 'a4', 'b1', 'd1']
                      },
                      {
                        label: 'Valor CIF',
                        subLabel: 'Bs.',
                        name: 'cifBs',
                        required: true,
                        type: 'number',
                        title: `${values.tc} * ${values?.cifUsd}`,
                        disabled: true,
                        func: (values) => {
                          let tc = parseFloat(values?.tc) || 0
                          let cifUsd = parseFloat(values?.cifUsd) || 0
                          let sum = tc * cifUsd;
                          setFieldValue('cifBs', roundToNearest(sum))
                        },
                        execFuncDependecy: (values) => [values?.tc, values?.cifUsd],
                        markEdits: ['a1', 'a2', 'a4', 'b1', 'b1', 'd1']
                      },
                      {
                        label: 'Quincenas',
                        subLabel: '',
                        name: 'quincenas',
                        required: true,
                        type: 'number',
                        markEdits: ['b1']
                      },
                      {
                        label: 'GA %',
                        subLabel: '',
                        name: 'ga',
                        required: true,
                        type: 'number',
                        markEdits: ['a1']
                      },
                      {
                        label: 'IVA %',
                        subLabel: '',
                        name: 'iva',
                        required: true,
                        type: 'number',
                        markEdits: ['a2']
                      },
                      {
                        label: '(J) Tiene descuento',
                        subLabel: '',
                        name: 'tieneDescuento',
                        type: 'checkbox'
                      },
                    ].map((i, idx) => (
                      <Input
                        key={idx}
                        {...i}
                        values={values}
                        setFieldValue={setFieldValue}
                        placeholder='0'
                      />
                    ))
                  }
                </TableInfo>
                <TableInfo>
                  <SubTitleDivider
                    text={'DATOS DE ADUANA'}
                  />
                  {
                    [
                      {
                        label: 'Aduana',
                        subLabel: '',
                        name: 'aduana',
                        required: true,
                        type: 'select',
                        isBigValue: true,
                        options: aduanas?.map(l => ({ label: l.name, value: l.name, }))
                      },

                      {
                        label: '(B) Tipo de Despacho',
                        subLabel: '',
                        name: 'tipoDespacho',
                        required: true,
                        type: 'select',
                        isBigValue: true,
                        options: [
                          {
                            label: 'AEREO',
                            value: 'AEREO',
                          },
                          {
                            label: 'TERRESTRE/MULTIMODAL',
                            value: 'TERRESTRE/MULTIMODAL',
                          },
                        ],
                        func: (values) => {
                          let aduana = values.aduana;
                          if (aduana.substring(1).startsWith('11')) {
                            setFieldValue('tipoDespacho', 'AEREO')
                          }
                          else if (aduana === null || aduana === '') {
                            setFieldValue('tipoDespacho', '')
                          }
                          else {
                            setFieldValue('tipoDespacho', 'TERRESTRE/MULTIMODAL')
                          }
                        },
                        execFuncDependecy: (values) => [
                          values?.aduana,
                        ],
                        markEdits: ['b2', 'c4']
                      },
                      {
                        label: 'Modalidad',
                        subLabel: '',
                        name: 'modalidad',
                        required: true,
                        type: 'select',
                        isBigValue: true,
                        options: modalidades?.map(l => ({ label: l.name, value: l.name, }))
                      },
                      {
                        label: 'Items',
                        subLabel: '',
                        name: 'items',
                        required: true,
                        type: 'number',
                        markEdits: ['c1', 'c2', 'c3', 'c4', 'c5']
                      },
                      {
                        label: 'Levante de abandono',
                        subLabel: '',
                        name: 'levanteAbandono',
                        required: true,
                        type: 'select',
                        isBigValue: true,
                        options: [
                          {
                            label: 'SI',
                            value: 'SI',
                          },
                          {
                            label: 'NO',
                            value: 'NO',
                          }
                        ],
                        markEdits: ['a4']
                      },
                      {
                        label: 'Reimpresión de PRM',
                        subLabel: '',
                        name: 'reimpresionDePrm',
                        type: 'select',
                        required: true,
                        isBigValue: true,
                        options: [
                          {
                            label: 'SI',
                            value: 'SI',
                          },
                          {
                            label: 'NO',
                            value: 'NO',
                          }
                        ],
                        markEdits: ['b3']
                      },
                      {
                        label: 'Multa Contravención (ufv)',
                        subLabel: '',
                        name: 'ufv',
                        type: 'select',
                        required: true,
                        isBigValue: true,
                        options: [
                          {
                            label: '0',
                            value: '0',
                          },
                          {
                            label: '100',
                            value: '100',
                          },
                          {
                            label: '150',
                            value: '150',
                          },
                          {
                            label: '250',
                            value: '250',
                          },
                          {
                            label: '500',
                            value: '500',
                          },
                        ],
                        markEdits: ['a5']
                      },
                    ].map((i, idx) => (
                      <Input
                        {...i}
                        key={idx}
                        values={values}
                        setFieldValue={setFieldValue}
                      />
                    ))
                  }
                  <SubTitleDivider
                    text={' PARAMETROS'}
                  />
                  {
                    [
                      {
                        label: '(A) Tipo de Cambio UFV',
                        subLabel: '',
                        name: 'tcUfv',
                        required: true,
                        disabled: true,
                        type: 'number',
                        markEdits: ['a5']
                      },
                    ].map((i, idx) => (
                      <Input
                        {...i}
                        key={idx}
                        values={values}
                        setFieldValue={setFieldValue}
                      />
                    ))
                  }
                </TableInfo>
                <TableInfo>
                  <SubTitleDivider
                    text={'CARGA Y TRANSPORTE'}
                  />
                  {
                    [
                      {
                        label: 'Bultos',
                        subLabel: '',
                        name: 'bultos',
                        isBigValue: true,
                        required: true,
                        type: 'number'
                      },
                      {
                        label: 'Peso',
                        subLabel: '',
                        name: 'peso',
                        isBigValue: true,
                        required: true,
                        type: 'number',
                        markEdits: ['tarifa1', 'b1', 'b5']
                      },
                      {
                        label: 'Transportadora',
                        subLabel: '',
                        name: 'transportadora',
                        required: true,
                        type: 'select',
                        isBigValue: true,
                        // options: parametros.transportadoras.map((i) => ({
                        //   label: i.label,
                        //   value: i.label,
                        // })),
                        options: transportadorasList?.map((i) => ({
                          label: i.name,
                          value: i.name,
                        })),
                        markEdits: ['b4', 'c7']
                      },
                      {
                        label: '(D) Transporte Local',
                        subLabel: '',
                        name: 'transporteLocal',
                        type: 'checkbox',
                        markEdits: ['b2']
                      },
                      {
                        label: 'Peso',
                        subLabel: '',
                        name: 'tipoPeso',
                        required: true,
                        type: 'select',
                        isBigValue: true,
                        options: [
                          {
                            label: 'MINIMA',
                            value: 'MINIMA',
                          },
                          {
                            label: 'NORMAL',
                            value: 'NORMAL',
                          },
                          {
                            label: 'MEDIO',
                            value: 'MEDIO',
                          },
                          {
                            label: 'ALTO',
                            value: 'ALTO',
                          },
                          {
                            label: 'MUY ALTO',
                            value: 'MUY ALTO',
                          },
                        ],
                        markEdits: ['b2']
                      },
                      {
                        label: 'Distancia',
                        subLabel: '',
                        name: 'distancia',
                        required: true,
                        type: 'select',
                        isBigValue: true,
                        options: [
                          {
                            label: 'NORMAL',
                            value: 'NORMAL',
                          },
                          {
                            label: 'MEDIA',
                            value: 'MEDIA',
                          },
                          {
                            label: 'LEJANA',
                            value: 'LEJANA',
                          },
                          {
                            label: 'MUY LEJANA',
                            value: 'MUY LEJANA',
                          },
                        ],
                        markEdits: ['b2']
                      },
                      {
                        label: 'Sobredimensión',
                        subLabel: '',
                        name: 'sobredimension',
                        required: true,
                        type: 'select',
                        isBigValue: true,
                        options: [
                          {
                            label: 'NORMAL',
                            value: 'NORMAL',
                          },
                          {
                            label: 'SD (A) 1',
                            value: 'SD (A) 1',
                          },
                          {
                            label: 'SD (A) 2',
                            value: 'SD (A) 2',
                          },
                          {
                            label: 'SD (A) 3',
                            value: 'SD (A) 3',
                          },
                          {
                            label: 'SD (A) 4',
                            value: 'SD (A) 4',
                          },
                        ],
                        markEdits: ['b2']
                      },
                      {
                        label: '(E) Nro. Estibadores',
                        subLabel: '',
                        name: 'nroEstibadores',
                        required: true,
                        type: 'number',
                        markEdits: ['b6']
                      },
                      {
                        label: 'Dificultad de Estibaje',
                        subLabel: '',
                        name: 'dificultadCarga',
                        required: true,
                        type: 'select',
                        isBigValue: true,
                        options: [
                          {
                            label: 'NORMAL',
                            value: 'NORMAL',
                          },
                          {
                            label: 'MEDIA',
                            value: 'MEDIA',
                          },
                          {
                            label: 'ALTA',
                            value: 'ALTA',
                          },
                          {
                            label: 'MUY ALTA',
                            value: 'MUY ALTA',
                          },
                        ],
                        markEdits: ['b6']
                      },
                    ].map((i, idx) => (
                      <Input
                        {...i}
                        key={idx}
                        values={values}
                        setFieldValue={setFieldValue}
                      />
                    ))
                  }
                </TableInfo>
                <TableInfo>
                  <SubTitleDivider
                    text={'GASTOS DE ALMACÉN'}
                  />
                  {
                    [
                      {
                        label: '(C) Tarifa por examén previo (ALBO S.A.)',
                        subLabel: '',
                        name: 'tarifaPorExamenPrevioAlbo',
                        type: 'checkbox',
                        markEdits: ['b5']
                      },
                      {
                        label: 'Valor tarífa 1',
                        subLabel: '',
                        name: 'tarifa1',
                        required: true,
                        type: 'number',
                        func: (values) => {
                          if (!(values.tarifa1Edit || dataProcedure.tarifa1 === null || dataProcedure.tarifa1 === '' || dataProcedure.tarifa1 === '-')) return;
                          let peso = parseFloat(values?.peso?.replace(',', '.')) || 0
                          let sum = (peso * 0.2) * 6.96;
                          setFieldValue('tarifa1', sum)
                        },
                        execFuncDependecy: (values) => [
                          values?.peso,
                        ],
                        markEdits: ['b5']
                      },
                      {
                        label: 'Valor tarífa 2',
                        subLabel: '',
                        name: 'tarifa2',
                        required: true,
                        type: 'number',
                        markEdits: ['b5']
                      },
                      {
                        label: '(F) Examen Previo al Despacho (Form.138)',
                        subLabel: '',
                        name: 'examenPrevio',
                        required: true,
                        type: 'checkbox',
                        markEdits: ['c2']
                      },
                      {
                        label: '(H) Examén previo',
                        subLabel: '',
                        name: 'exPrev',
                        required: true,
                        type: 'select',
                        isBigValue: true,
                        options: [
                          {
                            label: 'NORMAL (N)',
                            value: 'NORMAL (N)',
                          },
                          {
                            label: 'DIFICIL (D)',
                            value: 'DIFICIL (D)',
                          },
                          {
                            label: 'MUY DIFICIL (MD)',
                            value: 'MUY DIFICIL (MD)',
                          },
                          {
                            label: 'EXTREMADAMENTE DIFICIL (ED)',
                            value: 'EXTREMADAMENTE DIFICIL (ED)',
                          },
                        ],
                        markEdits: ['c2']
                      },
                    ].map((i, idx) => (
                      <Input
                        {...i}
                        key={idx}
                        values={values}
                        setFieldValue={setFieldValue}
                      />
                    ))
                  }
                  <SubTitleDivider
                    text={'GASTOS OPERATIVOS'}
                  />
                  {
                    [
                      {
                        label: '(G) Tiempo de Despacho',
                        subLabel: '',
                        name: 'gastosDespacho',
                        type: 'select',
                        required: true,
                        isBigValue: true,
                        options: [
                          {
                            label: 'CORTO (C)',
                            value: 'CORTO (C)',
                          },
                          {
                            label: 'MEDIO (M)',
                            value: 'MEDIO (M)',
                          },
                          {
                            label: 'LARGO (L)',
                            value: 'LARGO (L)',
                          },
                        ],
                        markEdits: ['c1']
                      },
                      {
                        label: 'Gastos de Despacho Dificultad',
                        subLabel: '',
                        name: 'gastosDespachoDificultad',
                        required: true,
                        type: 'select',
                        isBigValue: true,
                        options: [
                          {
                            label: 'NORMAL (N)',
                            value: 'NORMAL (N)',
                          },
                          {
                            label: 'DIFICIL (D)',
                            value: 'DIFICIL (D)',
                          },
                          {
                            label: 'MUY DIFICIL (MD)',
                            value: 'MUY DIFICIL (MD)',
                          },
                          {
                            label: 'EXTREMADAMENTE DIFICIL (ED)',
                            value: 'EXTREMADAMENTE DIFICIL (ED)',
                          },
                        ],
                        markEdits: ['c1']
                      },
                      {
                        label: '(I) Gestiones Senasag',
                        subLabel: '',
                        name: 'gestionesSenasag',
                        required: true,
                        type: 'select',
                        isBigValue: true,
                        options: [
                          { label: 'INSPECCION SENASAG', value: 'INSPECCION SENASAG' },
                          { label: 'PERMISO DE IMPORTACION DE MUESTRAS', value: 'PERMISO DE IMPORTACION DE MUESTRAS' },
                          { label: 'NINGUNO', value: 'NINGUNO' },
                        ],
                        markEdits: ['c6']
                      },
                    ].map((i, idx) => (
                      <Input
                        {...i}
                        key={idx}
                        values={values}
                        setFieldValue={setFieldValue}
                      />
                    ))
                  }
                </TableInfo>
              </div>
              <div className='col-span-12 grid grid-cols-12 gap-1'>
                <SubTitleDivider
                  text={'DETALLE DE CARGOS Y SERVICIOS'}
                />
                {
                  [
                    {
                      slab: 'A- TRIBUTOS ADUANEROS E IMPUESTOS',
                      nameList: 'aSelected',
                      list: aList,
                      subTotal: 'aTotal',
                      func: (values) => {
                        let a1 = parseFloat(values?.a1) || 0;
                        let a2 = parseFloat(values?.a2) || 0;
                        let a3 = parseFloat(values?.a3) || 0;
                        let a4 = parseFloat(values?.a4) || 0;
                        let a5 = parseFloat(values?.a5) || 0;
                        const amountSum = (values.aSelected || []).reduce((acc, item) => acc + (parseFloat(item.amount) || 0), 0);
                        let sum = a1 + a2 + a3 + a4 + a5 + amountSum;

                        setFieldValue('aTotal', sum.toFixed(2))
                      },
                      execFuncDependecy: (values) => [
                        values?.a1,
                        values?.a2,
                        values?.a3,
                        values?.a4,
                        values?.a5,
                        values?.aSelected
                      ],
                      options: [
                        {
                          label: 'DERECHOS Y GRAVAMENES ADUANEROS (G.A.)',
                          name: 'a1',
                          func: (values) => {
                            if (!(values.a1Edit || dataProcedure.a1 === null || dataProcedure.a1 === "0" || dataProcedure.a1 === '' || dataProcedure.a1 === '-')) return;
                            let cifBs = parseFloat(values?.cifBs) || 0
                            let ga = parseFloat(values?.ga) || 0
                            let sum = cifBs * (ga / 100);
                            setFieldValue('a1', sum.toFixed(2))
                          },
                          execFuncDependecy: (values) => [
                            values?.cifBs,
                            values?.ga
                          ],
                          markEdits: ['a2']
                        },
                        {
                          label: 'IMPUESTO AL VALOR AGREGADO (I.V.A.)',
                          name: 'a2',
                          func: (values) => {
                            if (!(values.a2Edit || dataProcedure.a2 === null || dataProcedure.a1 === "0" || dataProcedure.a2 === '' || dataProcedure.a2 === '-')) return;
                            let cifBs = parseFloat(values?.cifBs) || 0;
                            let a1 = parseFloat(values?.a1) || 0;
                            let iva = parseFloat(values?.iva) || 0;
                            let sum = (cifBs + a1) * (iva / 100);
                            setFieldValue('a2', roundToNearest(sum))
                          },
                          execFuncDependecy: (values) => [
                            values?.cifBs,
                            values?.a1,
                            values?.iva
                          ],
                        },
                        {
                          label: '197 USO FORMULARIO DIGITAL',
                          name: 'a3',
                        },
                        {
                          label: 'LEVANTAMIENTO DE ABANDONO (3% VALOR CIF Bs.)',
                          name: 'a4',
                          func: (values) => {
                            if (!(values.a4Edit || dataProcedure.a4 === null || dataProcedure.a4 === '' || dataProcedure.a4 === '-')) return;
                            let cifBs = parseFloat(values?.cifBs) || 0;
                            let levanteAbandono = values?.levanteAbandono

                            if (levanteAbandono === "SI") {
                              let sum = cifBs * 0.03;
                              setFieldValue('a4', sum.toFixed(2))
                            }
                            else {
                              setFieldValue('a4', 0)
                            }
                          },
                          execFuncDependecy: (values) => [
                            values?.cifBs,
                            values?.levanteAbandono,
                          ],
                        },
                        {
                          label: 'MULTA POR CONTRAVENCION',
                          name: 'a5',
                          func: (values) => {
                            if (!(values.a5Edit || dataProcedure.a5 === null || dataProcedure.a5 === '' || dataProcedure.a5 === '-')) return;
                            let ufv = parseFloat(values?.ufv) || 0
                            let tcUfv = parseFloat(values?.tcUfv) || 0
                            let sum = ufv * tcUfv;
                            setFieldValue('a5', sum.toFixed(2))
                          },
                          execFuncDependecy: (values) => [
                            values?.ufv,
                            values?.tcUfv,
                          ],
                        },
                      ]
                    },
                    {
                      slab: 'B- OTROS GASTOS DE IMPORTACION/EXPORTACION',
                      subTotal: 'bTotal',
                      list: bList,
                      nameList: 'bSelected',
                      func: (values) => {
                        let b1 = parseFloat(values?.b1) || 0;
                        let b2 = parseFloat(values?.b2) || 0;
                        let b3 = parseFloat(values?.b3) || 0;
                        let b4 = parseFloat(values?.b4) || 0;
                        let b5 = parseFloat(values?.b5) || 0;
                        let b6 = parseFloat(values?.b6) || 0;
                        const amountSum = (values.bSelected || []).reduce((acc, item) => acc + (parseFloat(item.amount) || 0), 0);
                        let sum = b1 + b2 + b3 + b4 + b5 + b6 + amountSum;
                        setFieldValue('bTotal', sum.toFixed(2))
                      },
                      execFuncDependecy: (values) => [
                        values?.b1,
                        values?.b2,
                        values?.b3,
                        values?.b4,
                        values?.b5,
                        values?.b6,
                        values?.bSelected
                      ],
                      options: [
                        {
                          label: 'ALMACENAJE ALBO/DAB',
                          name: 'b1',
                          func: (values) => {
                            if (!(values.b1Edit || dataProcedure.b1 === null || dataProcedure.b1 === '' || dataProcedure.b1 === '-')) return;
                            let cifBs = parseFloat(values?.cifBs) || 0;
                            let peso = parseFloat(values?.peso) || 0;
                            let quincenas = parseFloat(values?.quincenas) || 0;
                            // let tc = parseFloat(values?.tc)
                            let sum = (cifBs * (0.62 / 100)) + (peso * 0.09 * quincenas * 6.96);
                            setFieldValue('b1', sum.toFixed(2))
                          },
                          execFuncDependecy: (values) => [
                            values?.cifBs,
                            values?.peso,
                            values?.quincenas,
                            values?.tc,
                          ],
                        },
                        {
                          label: 'TRANSPORTE LOCAL',
                          name: 'b2',
                          func: (values) => {
                            if (!(values.b2Edit || dataProcedure.b2 === null || dataProcedure.b2 === '' || dataProcedure.b2 === '-')) return;
                            const { transporteLocal = false, tipoPeso, distancia, sobredimension, tipoDespacho } = values ?? {};
                            let resultado = 0;

                            if (tipoDespacho === 'AEREO' && transporteLocal === true) {
                              if (tipoPeso === "MINIMA") resultado += parametros.transporteLocal.aereo.peso['MINIMA'];
                              else if (tipoPeso === "NORMAL") resultado += parametros.transporteLocal.aereo.peso['NORMAL'];
                              else if (tipoPeso === "MEDIO") resultado += parametros.transporteLocal.aereo.peso['MEDIO'];
                              else if (tipoPeso === "ALTO") resultado += parametros.transporteLocal.aereo.peso['ALTO'];
                              else if (tipoPeso === "MUY ALTO") resultado += parametros.transporteLocal.aereo.peso['MUY ALTO'];
                            }

                            if (tipoDespacho === 'AEREO' && transporteLocal === true) {
                              if (distancia === "NORMAL") resultado += parametros.transporteLocal.aereo.distancia['NORMAL'];
                              else if (distancia === "MEDIA") resultado += parametros.transporteLocal.aereo.distancia['MEDIA'];
                              else if (distancia === "LEJANA") resultado += parametros.transporteLocal.aereo.distancia['LEJANA'];
                              else if (distancia === "MUY LEJANA") resultado += parametros.transporteLocal.aereo.distancia['MUY LEJANA'];
                            }

                            if (tipoDespacho === 'AEREO' && transporteLocal === true) {
                              if (sobredimension === "NORMAL") resultado += parametros.transporteLocal.aereo.sobredimension['NORMAL'];
                              else if (sobredimension === "SD (A) 1") resultado += parametros.transporteLocal.aereo.sobredimension['SD (A) 1'];
                              else if (sobredimension === "SD (A) 2") resultado += parametros.transporteLocal.aereo.sobredimension['SD (A) 2'];
                              else if (sobredimension === "SD (A) 3") resultado += parametros.transporteLocal.aereo.sobredimension['SD (A) 3'];
                              else if (sobredimension === "SD (A) 4") resultado += parametros.transporteLocal.aereo.sobredimension['SD (A) 4'];
                            }

                            if (tipoDespacho === 'TERRESTRE/MULTIMODAL' && transporteLocal === true) {
                              if (tipoPeso === "MINIMA") resultado += parametros.transporteLocal.terrestreMultimodal.peso['MINIMA'];
                              else if (tipoPeso === "NORMAL") resultado += parametros.transporteLocal.terrestreMultimodal.peso['NORMAL'];
                              else if (tipoPeso === "MEDIO") resultado += parametros.transporteLocal.terrestreMultimodal.peso['MEDIO'];
                              else if (tipoPeso === "ALTO") resultado += parametros.transporteLocal.terrestreMultimodal.peso['ALTO'];
                              else if (tipoPeso === "MUY ALTO") resultado += parametros.transporteLocal.terrestreMultimodal.peso['MUY ALTO'];
                            }

                            if (tipoDespacho === 'TERRESTRE/MULTIMODAL' && transporteLocal === true) {
                              if (distancia === "NORMAL") resultado += parametros.transporteLocal.terrestreMultimodal.distancia['NORMAL'];
                              else if (distancia === "MEDIA") resultado += parametros.transporteLocal.terrestreMultimodal.distancia['MEDIA'];
                              else if (distancia === "LEJANA") resultado += parametros.transporteLocal.terrestreMultimodal.distancia['LEJANA'];
                              else if (distancia === "MUY LEJANA") resultado += parametros.transporteLocal.terrestreMultimodal.distancia['MUY LEJANA'];
                            }

                            if (tipoDespacho === 'TERRESTRE/MULTIMODAL' && transporteLocal === true) {
                              if (sobredimension === "NORMAL") resultado += parametros.transporteLocal.terrestreMultimodal.sobredimension['NORMAL'];
                              else if (sobredimension === "SD (A) 1") resultado += parametros.transporteLocal.terrestreMultimodal.sobredimension['SD (A) 1'];
                              else if (sobredimension === "SD (A) 2") resultado += parametros.transporteLocal.terrestreMultimodal.sobredimension['SD (A) 2'];
                              else if (sobredimension === "SD (A) 3") resultado += parametros.transporteLocal.terrestreMultimodal.sobredimension['SD (A) 3'];
                              else if (sobredimension === "SD (A) 4") resultado += parametros.transporteLocal.terrestreMultimodal.sobredimension['SD (A) 4'];
                            }

                            setFieldValue('b2', resultado.toFixed(2))
                            // return resultado;
                          },
                          execFuncDependecy: (values) => [
                            values.transporteLocal,
                            values.tipoPeso,
                            values.distancia,
                            values.sobredimension,
                            values.tipoDespacho
                          ],
                        },
                        {
                          label: 'REIMPRESION DE PARTE DE RECEPCION',
                          name: 'b3',
                          func: (values) => {
                            if (!(values.b3Edit || dataProcedure.b3 === null || dataProcedure.b3 === '' || dataProcedure.b3 === '-')) return;
                            let reimpresionDePrm = values?.reimpresionDePrm
                            if (reimpresionDePrm === "SI") {
                              setFieldValue('b3', 34.80)
                            }
                            else {
                              setFieldValue('b3', 0)
                            }
                          },
                          execFuncDependecy: (values) => [
                            values?.reimpresionDePrm,
                          ],
                        },
                        {
                          label: 'RECOJO DE DOCUMENTO DE EMBARQUE',
                          name: 'b4',
                          func: (values) => {
                            if (!(values.b4Edit || dataProcedure.b4 === null || dataProcedure.b4 === '' || dataProcedure.b4 === '-')) return;
                            let transportadora = values?.transportadora
                            // let value = parametros.transportadoras.find((i) => i.label === transportadora)?.amount || '0'
                            let dataFound = transportadorasList.find((i) => i.name === transportadora)?.data || '0'
                            let value = (JSON.parse(dataFound))?.amount || '0'
                            if (value != null) {
                              setFieldValue('b4', parseFloat(value).toFixed(2))
                            }
                            else {
                              setFieldValue('b4', 0)
                            }
                          },
                          execFuncDependecy: (values) => [
                            values?.transportadora,
                          ],
                        },
                        {
                          label: 'TARIFA POR EXAMEN PREVIO (ALBO S.A.)',
                          name: 'b5',
                          func: (values) => {
                            if (!(values.b5Edit || dataProcedure.b5 === null || dataProcedure.b5 === '' || dataProcedure.b5 === '-')) return;
                            let tarifaPorExamenPrevioAlbo = values?.tarifaPorExamenPrevioAlbo
                            let tarifa1 = parseFloat(values?.tarifa1) || 0;
                            let tarifa2 = parseFloat(values?.tarifa2) || 0;
                            if (tarifaPorExamenPrevioAlbo && tarifa1 < tarifa2) {
                              setFieldValue('b5', tarifa1.toFixed(2))
                            }
                            else if (!tarifaPorExamenPrevioAlbo) {
                              setFieldValue('b5', 0)
                            }
                            else {
                              setFieldValue('b5', tarifa2.toFixed(2))
                            }
                          },
                          execFuncDependecy: (values) => [
                            values?.tarifaPorExamenPrevioAlbo,
                            values?.tarifa1,
                            values?.tarifa2,
                          ],
                        },
                        {
                          label: 'ESTIBAJE',
                          name: 'b6',
                          func: (values) => {
                            if (!(values.b6Edit || dataProcedure.b6 === null || dataProcedure.b6 === '' || dataProcedure.b6 === '-')) return;
                            let nroEstibadores = values?.nroEstibadores
                            let dificultadCarga = values?.dificultadCarga
                            let nroEstib = parametros.estibaje.cantidad[nroEstibadores];
                            let difEstib = parametros.estibaje.dificultad[dificultadCarga];
                            setFieldValue('b6', (nroEstib + difEstib).toFixed(2))

                          },
                          execFuncDependecy: (values) => [
                            values?.nroEstibadores,
                            values?.dificultadCarga,
                          ],
                        },
                      ]
                    },
                    {
                      slab: 'C- GASTOS DE OPERACIONES',
                      nameList: 'cSelected',
                      subTotal: 'cTotal',
                      list: cList,
                      func: (values) => {
                        let c1 = parseFloat(values?.c1) || 0;
                        let c2 = parseFloat(values?.c2) || 0;
                        let c3 = parseFloat(values?.c3) || 0;
                        let c4 = parseFloat(values?.c4) || 0;
                        let c5 = parseFloat(values?.c5) || 0;
                        let c6 = parseFloat(values?.c6) || 0;
                        let c7 = parseFloat(values?.c7) || 0;
                        const amountSum = (values.cSelected || []).reduce((acc, item) => acc + (parseFloat(item.amount) || 0), 0);
                        let sum = c1 + c2 + c3 + c4 + c5 + c6 + c7 + amountSum;
                        setFieldValue('cTotal', sum.toFixed(2))

                        let c1bk = parseFloat(values?.c1bk) || 0;
                        let c2bk = parseFloat(values?.c2bk) || 0;
                        let c3bk = parseFloat(values?.c3bk) || 0;
                        let c4bk = parseFloat(values?.c4bk) || 0;
                        let c5bk = parseFloat(values?.c5bk) || 0;
                        let c6bk = parseFloat(values?.c6bk) || 0;
                        let c7bk = parseFloat(values?.c7bk) || 0;
                        let sumbk = c1bk + c2bk + c3bk + c4bk + c5bk + c6bk + c7bk + amountSum;
                        setFieldValue('cTotalbk', sumbk.toFixed(2))
                      },
                      execFuncDependecy: (values) => [
                        values?.c1,
                        values?.c2,
                        values?.c3,
                        values?.c4,
                        values?.c5,
                        values?.c6,
                        values?.c7,
                        values?.cSelected
                      ],
                      options: [
                        {
                          label: 'GASTOS OPERATIVOS',
                          name: 'c1',
                          func: (values) => {
                            if (!(values.c1Edit || dataProcedure.c1 === null || dataProcedure.c1 === '' || dataProcedure.c1 === '-')) return;
                            let gastosDesp = values.gastosDespacho;
                            let gastosDespDific = values.gastosDespachoDificultad;
                            let resultado = 0
                            let items = parseFloat(values?.items) || 0
                            if (items >= 1 && items <= 5) resultado += 400;
                            else if (items >= 6 && items <= 10) resultado += 450;
                            else if (items >= 11 && items <= 20) resultado += 500;
                            else if (items >= 21 && items <= 30) resultado += 550;
                            else if (items >= 31 && items <= 40) resultado += 600;
                            else if (items >= 41 && items <= 50) resultado += 650;
                            else if (items >= 51) resultado += 700;

                            const valoresC8 = {
                              'NORMAL (N)': 0,
                              'DIFICIL (D)': 200,
                              'MUY DIFICIL (MD)': 300,
                              'EXTREMADAMENTE DIFICIL (ED)': 500
                            };
                            resultado += valoresC8[gastosDespDific] || 0;

                            const valoresC24 = {
                              'CORTO (C)': 0,
                              'MEDIO (M)': 100,
                              'LARGO (L)': 300
                            };
                            resultado += valoresC24[gastosDesp] || 0;
                            setFieldValue('c1', resultado.toFixed(2))
                          },
                          execFuncDependecy: (values) => [
                            values?.items,
                            values?.gastosDespacho,
                            values?.gastosDespachoDificultad,
                          ],
                        },
                        {
                          label: 'EXAMEN PREVIO AL DESPACHO (Form.138)',
                          name: 'c2',
                          func: (values) => {
                            if (!(values.c2Edit || dataProcedure.c2 === null || dataProcedure.c2 === '' || dataProcedure.c2 === '-')) return;
                            let items = parseInt(values.items);
                            let examenPrevio = values.examenPrevio;
                            let exPrev = values.exPrev;
                            let resultado = 0;

                            if (items >= 1 && items <= 5 && examenPrevio) {
                              resultado += 100;
                            } else if (items >= 6 && items <= 10 && examenPrevio) {
                              resultado += 150;
                            } else if (items >= 11 && items <= 20 && examenPrevio) {
                              resultado += 200;
                            } else if (items >= 21 && items <= 30 && examenPrevio) {
                              resultado += 200;
                            } else if (items >= 31 && items <= 40 && examenPrevio) {
                              resultado += 250;
                            } else if (items >= 41 && items <= 50 && examenPrevio) {
                              resultado += 300;
                            } else if (items >= 51) {
                              resultado += 350;
                            }

                            if (exPrev === 'NORMAL (N)' && examenPrevio) {
                              resultado += 0;
                            } else if (exPrev === 'DIFICIL (D)' && examenPrevio) {
                              resultado += 100;
                            } else if (exPrev === 'MUY DIFICIL (MD)' && examenPrevio) {
                              resultado += 200;
                            } else if (exPrev === 'EXTREMADAMENTE DIFICIL (ED)' && examenPrevio) {
                              resultado += 500;
                            }

                            setFieldValue('c2', resultado.toFixed(2))
                          },
                          execFuncDependecy: (values) => [
                            values?.items,
                            values?.examenPrevio,
                            values?.exPrev,
                          ],
                        },
                        {
                          label: 'DECLARACION ANDINA DE VALOR (DAV)',
                          name: 'c3',
                          func: (values) => {
                            if (!(values.c3Edit || dataProcedure.c3 === null || dataProcedure.c3 === '' || dataProcedure.c3 === '-')) return;
                            let fobSus = parseFloat(values.fobSus);
                            let items = parseInt(values.items);

                            if (fobSus < 5000) {
                              setFieldValue('c3', (0).toFixed(2))
                            }
                            else {
                              if (items >= 1 && items <= 5) {
                                setFieldValue('c3', (550).toFixed(2))
                              } else if (items >= 6 && items <= 10) {
                                setFieldValue('c3', (550).toFixed(2))
                              } else if (items >= 11 && items <= 20) {
                                setFieldValue('c3', (650).toFixed(2))
                              } else if (items >= 21 && items <= 30) {
                                setFieldValue('c3', (750).toFixed(2))
                              } else if (items >= 31 && items <= 40) {
                                setFieldValue('c3', (850).toFixed(2))
                              } else if (items >= 41 && items <= 50) {
                                setFieldValue('c3', (950).toFixed(2))
                              } else if (items >= 51) {
                                setFieldValue('c3', (950).toFixed(2))
                              }
                            }
                          },
                          execFuncDependecy: (values) => [
                            values?.fobSus,
                            values?.items,
                          ],
                        },
                        {
                          label: 'DECLARACION DE ADQUISICION DE MERCANCIAS (D.A.M.)',
                          name: 'c4',
                          func: (values) => {
                            if (!(values.c4Edit || dataProcedure.c4 === null || dataProcedure.c4 === '' || dataProcedure.c4 === '-')) return;
                            let items = parseInt(values.items);
                            let tipoDespacho = values.tipoDespacho;

                            if (tipoDespacho !== 'TERRESTRE/MULTIMODAL') {
                              setFieldValue('c4', (0).toFixed(2));
                            }
                            else {
                              if (items >= 1 && items <= 5) {
                                setFieldValue('c4', (350).toFixed(2));
                              } else if (items >= 6 && items <= 10) {
                                setFieldValue('c4', (350).toFixed(2));
                              } else if (items >= 11 && items <= 20) {
                                setFieldValue('c4', (400).toFixed(2));
                              } else if (items >= 21 && items <= 30) {
                                setFieldValue('c4', (400).toFixed(2));
                              } else if (items >= 31 && items <= 40) {
                                setFieldValue('c4', (400).toFixed(2));
                              } else if (items >= 41 && items <= 50) {
                                setFieldValue('c4', (400).toFixed(2));
                              } else if (items >= 51) {
                                setFieldValue('c4', (400).toFixed(2));
                              }
                            }

                          },
                          execFuncDependecy: (values) => [
                            values?.items,
                            values?.tipoDespacho,
                          ],
                        },
                        {
                          label: 'OTRAS GESTIONES DE IMPORTACION',
                          name: 'c5',
                          func: (values) => {
                            if (!(values.c5Edit || dataProcedure.c5 === null || dataProcedure.c5 === '' || dataProcedure.c5 === '-')) return;
                            let items = parseInt(values.items);
                            let fobSus = parseFloat(values.fobSus);

                            if (fobSus >= 5000) {
                              setFieldValue('c5', (0).toFixed(2));
                            }
                            else {
                              if (items >= 1 && items <= 5) {
                                setFieldValue('c5', (150).toFixed(2));
                              } else if (items >= 6 && items <= 10) {
                                setFieldValue('c5', (200).toFixed(2));
                              } else if (items >= 11 && items <= 20) {
                                setFieldValue('c5', (250).toFixed(2));
                              } else if (items >= 21 && items <= 30) {
                                setFieldValue('c5', (300).toFixed(2));
                              } else if (items >= 31 && items <= 40) {
                                setFieldValue('c5', (350).toFixed(2));
                              } else if (items >= 41 && items <= 50) {
                                setFieldValue('c5', (450).toFixed(2));
                              } else if (items >= 51) {
                                setFieldValue('c5', (500).toFixed(2));
                              }
                              else {
                                setFieldValue('c5', (0).toFixed(2));
                              }
                            }
                          },
                          execFuncDependecy: (values) => [
                            values?.items,
                            values?.fobSus,
                          ],
                        },
                        {
                          label: 'GESTIONES SENASAG',
                          name: 'c6',
                          func: (values) => {
                            if (!(values.c6Edit || dataProcedure.c6 === null || dataProcedure.c6 === '' || dataProcedure.c6 === '-')) return;
                            let gestionesSenasag = values.gestionesSenasag;
                            let param = parametros.gestionesSenasag[gestionesSenasag]
                            setFieldValue('c6', (param ?? 0).toFixed(2));
                          },
                          execFuncDependecy: (values) => [
                            values?.gestionesSenasag,
                          ],
                        },
                        {
                          label: 'LOGISTICA FD',
                          name: 'c7',
                          func: (values) => {
                            if (!(values.c7Edit || dataProcedure.c7 === null || dataProcedure.c7 === '' || dataProcedure.c7 === '-')) return;
                            let transportadora = values.transportadora;
                            let fobSus = parseFloat(values.fobSus);
                            if (transportadora === "UPS FD") {
                              if (fobSus <= 1999.99) {
                                setFieldValue('c7', (250).toFixed(2));
                              } else if (fobSus >= 2000) {
                                setFieldValue('c7', (313).toFixed(2));
                              }
                            }
                            else {
                              setFieldValue('c7', (0).toFixed(2));
                            }
                          },
                          execFuncDependecy: (values) => [
                            values?.transportadora,
                            values?.fobSus,
                          ],
                        },
                      ]
                    },
                    {
                      slab: 'D- SERVICIOS AGENCIA',
                      nameList: 'dSelected',
                      subTotal: 'dTotal',
                      list: dList,
                      func: (values) => {
                        let d1 = parseFloat(values?.d1)
                        let d2 = parseFloat(values?.d2)
                        const amountSum = (values.dSelected || []).reduce((acc, item) => acc + (parseFloat(item.amount) || 0), 0);
                        let sum = d1 + d2 + amountSum;
                        setFieldValue('dTotal', sum.toFixed(2))
                      },
                      execFuncDependecy: (values) => [
                        values?.d1,
                        values?.d2,
                        values?.dSelected
                      ],
                      options: [
                        {
                          label: 'SERVICIOS OPERACIONES ADUANERAS',
                          name: 'd1',
                          func: (values) => {
                            if (!(values.d1Edit || dataProcedure.d1 === null || dataProcedure.d1 === '' || dataProcedure.d1 === '-')) return;
                            let cifUsd = parseFloat(values?.cifUsd)
                            let cifBs = parseFloat(values?.cifBs)
                            let resultado = 500;

                            for (let rango of parametros.comisionAgencia) {
                              if (cifUsd >= rango.init && (rango.fin === undefined || cifUsd <= rango.fin)) {
                                let calculo = cifBs * (rango.percentage / 100);
                                if (calculo > 500) {
                                  resultado = calculo;
                                }
                                break;
                              }
                            }
                            let factor = 1;
                            // if (PARAMETROS.B30 === 5) {
                            //     factor = (100 - PARAMETROS.A30) / 100;
                            // } else if (PARAMETROS.B30 === 10) {
                            //     factor = (100 - PARAMETROS.A31) / 100;
                            // } else if (PARAMETROS.B26 === 15) {
                            //     factor = (100 - PARAMETROS.A32) / 100;
                            // } else if (PARAMETROS.B30 === 20) {
                            //     factor = (100 - PARAMETROS.A33) / 100;
                            // }
                            // return Math.round(resultado * factor);
                            setFieldValue('d1', (Math.round(resultado * factor)).toFixed(2))
                          },
                          execFuncDependecy: (values) => [
                            values?.cifUsd,
                            values?.cifBs,
                          ],
                        },
                        {
                          label: 'RESGUARDO DOCUMENTAL (CRDA)',
                          name: 'd2'
                        },
                      ]
                    },
                  ].map((i, idx) => (
                    <div key={idx} className='col-span-12 md:col-span-6 rounded-md bg-white border-2 border-[#587fb9] p-2'>
                      <div className='flex items-center justify-between mb-3'>
                        <h2 className='font-semibold'>{i.slab}</h2>
                        <span className='flex flex-col lg:flex-row gap-2'>
                          {
                            i.slab.startsWith('C') && values.c1bk &&
                            <span
                              className='bg-violet-300 text-black justify-center py-1 px-2 rounded-md hover:shadow-md flex items-center text-sm gap-2 cursor-pointer'
                              onClick={() => replaceCBlock(values, setFieldValue)}
                            >
                              <i className='fa fa-repeat text-[12px]' />
                              <span>Reemplazar</span>
                            </span>
                          }
                          {
                            i.slab.startsWith('C') && values.c1bk &&
                            <span
                              className='bg-red-400 text-black justify-center py-1 px-2 rounded-md hover:shadow-md flex items-center text-sm gap-2 cursor-pointer'
                              onClick={() => deleteeCBackBlock(values, setFieldValue)}
                            >
                              <i className='fa fa-xmark text-[12px]' />
                            </span>
                          }
                          {
                            i.slab.startsWith('C') &&
                            <span
                              className='bg-yellow-400 text-black justify-center py-1 px-2 rounded-md hover:shadow-md flex items-center text-sm gap-2 cursor-pointer'
                              onClick={() => callCBlockAverage(values, setFieldValue)}
                            >
                              <i className='fa fa-plus-minus text-[12px]' />
                              <span>Promediar</span>
                            </span>
                          }
                        </span>
                      </div>
                      <TableInfo>
                        {
                          i.options?.map((y, idy) => (
                            <Input
                              key={idy}
                              label={y.label}
                              subLabel={''}
                              name={y.name}
                              func={y.func}
                              type={'number'}
                              values={values}
                              col3={values[y.name + 'bk']}
                              execFuncDependecy={y.execFuncDependecy}
                              setFieldValue={setFieldValue}
                            // focus={i.focus ?? false}
                            />
                          ))
                        }
                        {
                          values[i.nameList]?.map((l, idxx) => (
                            <Input
                              key={idxx}
                              label={l.label}
                              subLabel={''}
                              name={l.cuenta}
                              type={'number'}
                              values={values}
                              defaultValue={l.amount}
                              onChange={l.onChange}
                              beforeButton={() => {
                                // setListSelected(prev => ({
                                //   ...prev,
                                //   [i.nameList]: prev[i.nameList]?.filter((_, i) => i !== idxx) || []
                                // }));
                                setFieldValue(i.nameList, values[i.nameList]?.filter((_, i) => i !== idxx) || []);
                              }}
                              setFieldValue={(name, value) => {
                                const updatedList = [...(values[i.nameList] || [])];
                                updatedList[idxx] = { ...updatedList[idxx], amount: value };
                                setFieldValue(i.nameList, updatedList);
                              }}
                              markEdits={l.markEdits}
                            />
                          ))
                        }
                        <SelectList
                          label={''}
                          subLabel={''}
                          name={i.nameList}
                          onChange={e => {
                            // setListSelected(prev => ({
                            //   ...prev,
                            //   [i.nameList]: [...(prev[i.nameList] || []), { label: e.label, cuenta: e.cuenta, amount: 0 }]
                            // }));
                            setFieldValue(i.nameList, [...(values[i.nameList] || []), { label: e.label, cuenta: e.cuenta, amount: 0 }]);
                          }}
                          type={'select'}
                          values={values}
                          options={i.list?.map(l => ({ label: l.name, value: l.name, cuenta: l.data }))}
                        />
                        <Input
                          label={'Sub-total'}
                          subLabel={''}
                          name={i.subTotal}
                          func={i.func}
                          type={'number'}
                          isBold={true}
                          values={values}
                          col3={values.c1bk && values[i.subTotal + 'bk']}
                          execFuncDependecy={i.execFuncDependecy}
                          disabled={true}
                          setFieldValue={setFieldValue}
                        />
                      </TableInfo>
                    </div>
                  ))
                }

              </div>
              <div className='col-span-12'>
                <Input
                  className='w-full'
                  label={'Observaciones'}
                  values={values}
                  name={'obs'}
                  type='textarea'
                  isBigValue={true}
                  setFieldValue={setFieldValue}
                  placeholder='Observaciones...'
                />
              </div>
              <div className='col-span-12'>
                <Input
                  className='w-full'
                  label={'Observaciones de proforma'}
                  values={values}
                  name={'obsProf'}
                  type='textarea'
                  isBigValue={true}
                  setFieldValue={setFieldValue}
                  placeholder='Observaciones...'
                />
              </div>
              <div className='col-span-12 flex gap-2 justify-between'>
                <div>
                  {/* <span>Últimos despachos de referencia</span> */}
                  <ul className='flex flex-col gap-1'>
                    {
                      initProcedure?.profReferences?.map(({ internCode, urlDoc }, idx) => (
                        <a key={idx} href={urlDoc} target='_blank' rel='noreferrer' className='flex gap-2 items-center hover:bg-[#3f649b30] justify-center rounded-full px-4'>
                          <span>{internCode}</span>
                          <i className='fa fa-up-right-from-square' />
                        </a>
                      ))
                    }
                  </ul>
                </div>
                <TableInfo>
                  {
                    [
                      {
                        label: 'Tributos Aduaneros, Otros Gastos y Factura (Bs.)',
                        subLabel: '',
                        name: 'tribAduaneros',
                        type: 'number',
                        func: (values) => {
                          let aTotal = parseFloat(values?.aTotal) || 0;
                          let bTotal = parseFloat(values?.bTotal) || 0;
                          let cTotal = parseFloat(values?.cTotal) || 0;
                          let dTotal = parseFloat(values?.dTotal) || 0;
                          let sum = aTotal + bTotal + cTotal + dTotal;
                          setFieldValue('tribAduaneros', sum.toFixed(2))
                        },
                        execFuncDependecy: (values) => [
                          values.aTotal,
                          values.bTotal,
                          values.cTotal,
                          values.dTotal,
                        ]
                      },
                      {
                        label: 'Descuento (Bs.)',
                        subLabel: '',
                        name: 'descuento',
                        type: 'number',
                        // func: (values) => {
                        // },
                        // execFuncDependecy: (values) => [values.fobSus]
                      },
                      {
                        label: 'Total Proforma (Bs.)',
                        subLabel: '',
                        name: 'totalProf',
                        type: 'number',
                        func: (values) => {
                          let tribAduaneros = parseFloat(values?.tribAduaneros) || 0;
                          let descuento = parseFloat(values?.descuento) || 0;
                          let sum = tribAduaneros - descuento;
                          setFieldValue('totalProf', sum.toFixed(2))
                        },
                        execFuncDependecy: (values) => [values.descuento, values.tribAduaneros]
                      },
                      {
                        label: 'Total Proforma $US (6.85)',
                        subLabel: '',
                        name: 'totalProfUsd',
                        type: 'number',
                        func: (values) => {
                          let totalProf = parseFloat(values?.totalProf) || 0;
                          let tc = 6.85;
                          let sum = totalProf / tc;
                          setFieldValue('totalProfUsd', sum.toFixed(2))
                        },
                        execFuncDependecy: (values) => [values.totalProf]
                      },
                    ].map((i, idx) => (
                      i.name === 'descuento' ?
                        (
                          values.tieneDescuento &&
                          <Input
                            {...i}
                            key={idx}
                            values={values}
                            isGeneral={true}
                            isBold={true}
                            setFieldValue={setFieldValue}
                          />
                        )
                        :
                        <Input
                          {...i}
                          key={idx}
                          values={values}
                          isGeneral={true}
                          isBold={true}
                          setFieldValue={setFieldValue}
                        />
                    ))
                  }
                </TableInfo>
              </div>
              <hr className='col-span-12' />
              <button
                type='input'
                className='
                col-span-12
                text-white
                focus:ring-2
                focus:outline-none
                focus:ring-[#587fb9]
                rounded-lg
                font-semibold
                text-sm
                px-5 py-2.5
                text-center
                bg-[#618BCC] hover:bg-[#587fb9]
                disabled:bg-gray-600 disabled:opacity-50
                transition-all
                duration-150
                '
                disabled={false}
              >
                Guardar
              </button>
            </Form>
          )}
        </Formik>
        {
          closeEscPress &&
          <div className='bg-gray-200 border border-[#618BCC] rounded-xl w-[320px] h-[140px] px-4 flex flex-col items-center gap-2 justify-center fixed top-[45%] left-[8%] xl:left-[38%] shadow-xl'>
            <span className='font-bold text-[15px]'>Los cambios no guardados se perderán.</span>
            <span className='font-bold text-[15px]'>¿Esta seguro de que desea salir?</span>
            <Button className='w-full' onClick={() => close()}>Salir</Button>
          </div>
        }
      </div>
    )
  }
}

const Input = ({ label, subLabel, type = 'text', name, values, setFieldValue, options, focus = false, func, placeholder = '', isBigValue = false, execFuncDependecy, disabled = false, beforeButton, isGeneral = false, isBold = false, defaultValueOption = null, defaultValue = null, required = false, markEdits = [], col3, title = '' }) => {
  const handleInputChange = (e) => {
    if (type === 'checkbox') {
      setFieldValue(name, e.target.checked);
    }
    else {
      setFieldValue(name, e.target.value);
    }
  };

  useEffect(() => {
    if (func) {
      func(values, setFieldValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...(execFuncDependecy ? execFuncDependecy(values) : [])]);

  switch (type) {
    case 'checkbox':
      return (
        <>
          <div className="col-span-12 flex items-center border px-0.5 border-[#3f649b80]">
            <Field
              id={name}
              type={type}
              name={name}
              onChange={(e) => {
                handleInputChange(e)
                markEdits.map(x => setFieldValue(x + "Edit", true))
              }}
              className="m-3 cursor-pointer text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
              disabled={disabled}
            />
            <label htmlFor={name} title={label} className={`flex items-center justify-between h-full text-sm font-semibold whitespace-nowrap overflow-hidden p-1`}>
              {label}
            </label>
          </div>
        </>
      )
    case 'createSelect':
    case 'select':
      return (
        <div className="grid grid-cols-12 col-span-12 items-start">
          <label htmlFor={name} title={label} className={`flex items-center justify-between ${isBigValue ? 'col-span-5' : 'col-span-7'} border-l border-t border-b border-[#3f649b80] h-full text-sm font-semibold whitespace-nowrap overflow-hidden p-1`}>
            <span className='overflow-hidden'>
              {label}
            </span>
            <span className="text-end">{subLabel}:</span>
          </label>
          <Field
            id={name}
            name={name}
            required={required}
            disabled={disabled}
          >
            {() => {
              const defaultValue = defaultValueOption
                ? defaultValueOption
                : values[name]
                  ? { label: values[name], value: values[name] }
                  : null;

              return (
                type === 'createSelect' ?
                  <CreatableSelect
                    id={name}
                    options={options}
                    value={defaultValue}
                    className={`${isBigValue ? 'col-span-7' : 'col-span-5'} shadow-sm outline-none text-gray-900 text-sm ${type === 'number' ? 'text-end' : ''} focus:ring-blue-600 focus:border-blue-600 block w-full font-semibold disabled:opacity-85 disabled:bg-[#3f649b30]`}
                    placeholder='Seleccionar...'
                    onChange={(selectedOption) => {
                      setFieldValue(name, selectedOption ? selectedOption.value : null); // Actualiza el valor con solo el valor
                      markEdits.map(x => setFieldValue(x + "Edit", true));
                    }}
                    styles={{
                      control: (styles) => ({
                        ...styles,
                        borderRadius: 'none',
                        borderColor: '#3f649b80',
                        background: execFuncDependecy ? '#fbe3d4' : ''
                      })
                    }}
                  />
                  :
                  <Select
                    id={name}
                    options={options}
                    value={defaultValue}
                    className={`${isBigValue ? 'col-span-7' : 'col-span-5'} shadow-sm outline-none text-gray-900 text-sm ${type === 'number' ? 'text-end' : ''} focus:ring-blue-600 focus:border-blue-600 block w-full font-semibold disabled:opacity-85 disabled:bg-[#3f649b30]`}
                    placeholder='Seleccionar...'
                    onChange={(selectedOption) => {
                      setFieldValue(name, selectedOption ? selectedOption.value : null); // Actualiza el valor con solo el valor
                      markEdits.map(x => setFieldValue(x + "Edit", true));
                    }}
                    styles={{
                      control: (styles) => ({
                        ...styles,
                        borderRadius: 'none',
                        borderColor: '#3f649b80',
                        background: execFuncDependecy ? '#fbe3d4' : ''
                      })
                    }}
                  />
              );
            }}
          </Field>
        </div>
      );
    case 'textarea':
      return (
        <>
          <div className="col-span-12 flex flex-col p-2 border border-[#3f649b80]">
            <label htmlFor={name} title={label} className={`flex h-full text-sm font-semibold whitespace-nowrap overflow-hidden`}>
              {label}
            </label>
            <Field
              id={name}
              // type={type}
              as='textarea'
              row={1}
              name={name}
              onChange={(e) => {
                handleInputChange(e)
                markEdits.map(x => setFieldValue(x + "Edit", true))
              }}
              className="p-2 w-full text-[#3f649b] bg-gray-100 border-gray-300 rounded border border-[#3f649b80] focus:ring-blue-500 dark:focus:ring-blue-600 "
              disabled={disabled}
            />
          </div>
        </>
      )
    default:
      return (
        <div className={`grid grid-cols-12 col-span-12 items-start relative`} title={title}>
          {
            beforeButton &&
            <span onClick={() => beforeButton()} className='absolute text-yellow-600 bg-white px-0.5 -left-4 top-0.5 rounded-full cursor-pointer' >
              <i className={`fa fa-circle-xmark p-0 text-lg`} />
            </span>
          }
          <label htmlFor={name} title={label + ' ' + title} className={`flex items-center  ${isGeneral ? 'justify-end' : 'justify-between'} ${isBold ? 'font-bold' : 'font-semibold'} ${isBigValue ? 'col-span-5' : 'col-span-7'} border-l border-t border-b border-[#3f649b80] h-full text-sm whitespace-nowrap overflow-hidden p-1`}>
            <span className='overflow-hidden'>
              {label}
            </span>
            <span className="text-end">{subLabel}:</span>
          </label>
          <Field
            as="input"
            type={type}
            name={name}
            id={name}
            step="any"
            required={required}
            defaultValue={defaultValue}
            onChange={(e) => {
              handleInputChange(e);
              markEdits.map(x => setFieldValue(x + "Edit", true))
            }}
            onKeyDown={(e) => {
              if (type === 'number' && (e.key === 'ArrowUp' || e.key === 'ArrowDown')) {
                e.preventDefault();
              }
              const inputs = Array.from(document.querySelectorAll('input:not([disabled])'));
              const index = inputs.findIndex(input => input === e.target);

              if (e.key === 'ArrowUp' && index > 0) {
                e.preventDefault();
                inputs[index - 1].focus();
              }
              if (e.key === 'ArrowDown' && index < inputs.length - 1) {
                e.preventDefault();
                inputs[index + 1].focus();
              }
            }}
            className={`${isBigValue ? 'col-span-7' : col3 ? 'col-span-3' : 'col-span-5'} shadow-sm outline-none border border-[#3f649b80] text-gray-900 text-sm ${type === 'number' ? 'text-end' : ''} focus:ring-blue-600 focus:border-blue-600 block w-full p-1 disabled:opacity-85 disabled:bg-[#3f649b30] ${execFuncDependecy ? 'bg-[#fbe3d4]' : ''} ${isBold ? 'font-bold' : 'font-semibold'}`}
            placeholder={placeholder}
            disabled={disabled}
            autoComplete="off"
            autoFocus={focus}
          />
          {
            col3 &&
            <span
              className={`col-span-2 shadow-sm outline-none border-t border-b border-r border-[#3f649b80] text-gray-900 bg-yellow-100 text-sm ${type === 'number' ? 'text-end' : ''} focus:ring-blue-600 focus:border-blue-600 block w-full p-1 disabled:opacity-85 disabled:bg-[#3f649b30] ${isBold ? 'font-bold' : 'font-semibold'}`}
            >{col3}</span>
          }
        </div>
      );
  }
};

const SelectList = ({ options, name, onChange }) => {
  const [selectedOption, setSelectedOption] = useState(null);

  return (
    <div className="col-span-12 w-full flex">
      <Field id={name} name={name}>
        {() => (
          <Select
            id={name}
            options={options}
            placeholder="Seleccionar..."
            value={selectedOption}
            onChange={(e) => {
              setSelectedOption(null);
              onChange(e);
            }}
            className="shadow-sm outline-none text-gray-800 text-sm focus:ring-blue-600 focus:border-blue-600 block w-full font-semibold disabled:opacity-85 disabled:bg-[#3f649b30]"
            styles={{
              control: (styles) => ({
                ...styles,
                borderRadius: "none",
                borderColor: "#3f649b80",
                background: "#3f649b30",
                color: "#e5e7eb",
              }),
            }}
          />
        )}
      </Field>
    </div>
  );
};

const TableInfo = ({ children }) => {
  return <div className='grid grid-cols-12 col-span-12 sm:col-span-6 lg:col-span-3 gap-1 transition-all duration-300 hover:shadow-lg shadow-[#587fb9]'>{children}</div>
}
const TableInfo2 = ({ children }) => {
  return <div className='grid grid-cols-12 col-span-12 sm:col-span-6 gap-1 transition-all duration-300 hover:shadow-lg shadow-[#587fb9]'>{children}</div>
}
const TableInfo3 = ({ children }) => {
  return <div className='col-span-12 grid grid-cols-12 gap-1 items-start transition-all duration-300 hover:shadow-lg shadow-[#587fb9]'>{children}</div>
}

const SubTitleDivider = ({ text, color = '[#587fb9]' }) => {
  return <div className={`col-span-12 gap-1 items-start bg-[#587fb9] text-white px-2 py-1`}>
    <h1 className='font-bold text-md'>{text}</h1>
  </div>
}

export default ProformGeneratorForm